'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var appDom = require('../../app-dom');
var scrollToElement = require('scroll-to-element');

var dom;
var addToCartText;

var setupDom = function() {

	dom = {};
	dom.schedulerDetail = $('.scheduler-detail');
	dom.serviceForm = dom.schedulerDetail.find('.scheduler-detail__form');

};

var addEventHandlers = function() {

	console.log('ADD SCHEDULER DETAIL FORM EVENT HANDLERS!');

	dom.schedulerDetail.off('.scheduler_detail');
	dom.schedulerDetail.on('change.scheduler_detail', '.scheduler-detail__option', onServiceOptionChanged);
	dom.schedulerDetail.on('click.scheduler_detail', '.js-schedule-btn', onScheduleBtnClicked);
	appDom.document.off('.scheduler_detail');
	appDom.document.on('item_added_to_cart.scheduler_detail', onItemAddedToCart);

};

var onScheduleBtnClicked = function() {

	triggerCustomEvent('schedule_button_clicked');

};

var onItemAddedToCart = function() {

	notify.hide();

	resetServiceForm();

};

var resetServiceForm = function() {

	var $selectBoxes = dom.serviceForm.find('select');
	var $textInputs = dom.serviceForm.find('input[type="text"]');
	var $textareas = dom.serviceForm.find('textarea');
	var $addToCartBtn = dom.serviceForm.find('.scheduler-detail__add-to-cart-btn');

	$selectBoxes.each(function(i, el) {

		$(el).find('option:eq(0)').attr('selected', 'selected');

	});

	$textInputs.each(function(i, el) {

		$(el).val('');

	});

	$textareas.each(function(i, el) {

		$(el).val('');

	});

	loadServiceForm();

};

var onServiceOptionChanged = function() {

	var $selectedOption = $(this).find('option:selected');

	dom.serviceForm = $(this).parents('.scheduler-detail__form');

	notify.hide();

	loadServiceForm();

};

var loadServiceForm = function(isInitialLoad) {

	isInitialLoad = typeof isInitialLoad !== 'undefined' ? isInitialLoad : false;

	dom.serviceForm.each(function(i, el, a) {

		console.log(el);

		$.ajax({
			url: '/index.cfm?action=scheduler.detailForm',
			method: 'POST',
			data: dom.serviceForm.eq(i).serialize() + '&isInitialLoad=' + isInitialLoad
		}).done(onLoadServiceFormDone);

	});

};

var onLoadServiceFormDone = function(response) {

	var $cachedForm = dom.serviceForm;

	if (response.status) {

		dom.serviceForm.filter('[data-item-id=' + response.itemId + ']').html(response.markup);

		setupDom();

		addEventHandlers();

	}

};

var init = function() {

	setupDom();

	loadServiceForm(true);

};

module.exports = {
	init: init
};
